import { CHECKLIST_ITEM_TYPE } from 'src/constants/tasksV2';

export default {
    id: 10,
    type: CHECKLIST_ITEM_TYPE.LOG_PHONE_CALL,
    manifestKey: 'LOG_PHONE_CALL',

    try_it: {
        button_label: 'Log Phone Call (detailed)',
        cell_component_import: {
            from: 'src/pages/dashboard/tables/AllLeadTable/TaskChecklistField',
            named: 'LogPhoneCallCell',
        },
        prefill: {
            completion_state: 'YES',
            response_payload: { duration_seconds: 60, outcome: 'Patient confirmed appointment' },
        },
    },
    pre_flight_diff: [
        'Log phone call dialog opens — captures duration and outcome',
        'Checklist item: PENDING → YES',
        'TaskActivity row created with CHECKLIST_ITEM_COMPLETED',
        'Signal receiver does NOT emit a redundant action verb on lead timeline',
        'No lead status change',
    ],
    has_step2_throttle: false,
    validation_laboratory: null,
};
